var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var delimiters_1 = require("./delimiters");
var valueNode_1 = require("./valueNode");
var fieldRepetition_1 = require("./fieldRepetition");
var Field = (function (_super) {
    __extends(Field, _super);
    function Field(parent, key, text) {
        _super.call(this, parent, key, text, delimiters_1.default.Repetition);
    }
    Field.prototype.read = function (path) {
        if (this.children.length > 0) {
            return this.children[0].read(path);
        }
        return null;
    };
    Field.prototype.writeCore = function (path, value) {
        return this._ensureChild().write(path, value);
    };
    Field.prototype.createChild = function (text, index) {
        return new fieldRepetition_1.default(this, this.key, text);
    };
    Field.prototype._ensureChild = function () {
        var child;
        // create a repetition if we do not have one already
        if (this.children.length == 0) {
            child = this.createChild("", 0);
            this.setChild(child, 0);
        }
        else {
            child = this.children[0];
        }
        return child;
    };
    return Field;
})(valueNode_1.default);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Field;
